module.exports = __webpack_public_path__ + "img/weight-apple.ee9c5980.png";